










































import { Component, Mixins } from "vue-property-decorator";
import { DuplicatedPatientSelector } from "../selectors";
import { DuplicatedPatientSelectorDialogMixin} from "./mixin";

@Component({
  components: {
    DuplicatedPatientSelector,
  },
})
export default class DuplicatedPatientSelectorDialog extends Mixins(DuplicatedPatientSelectorDialogMixin) {
}
